// The files panel of the form that creates a deal (TX-US-0039). There is no deal to attach to
// until the form is saved, so a dropped file waits here; the form uploads the queue once the save
// has given the deal its identifier. The policy is the deal page's (TX-US-0031), and with the
// deal flow on each waiting file is asked what it is, as on the deal's page (TX-US-0043).

import PendingFile from '../counterparties/documents/PendingFile.jsx';
import { flowOn } from '../deals/flow.js';
import { useMe } from '../MeContext.js';
import DropZone from '../ui/DropZone.jsx';
import { ACCEPT, FORMATS_HINT } from './dealFiles.js';
import PendingTypedFile from './PendingTypedFile.jsx';

export default function StagedDealFiles({ uploads, disabled }) {
  const Row = flowOn(useMe()) ? PendingTypedFile : PendingFile;

  return (
    <fieldset className="attachments">
      <legend>Documents</legend>
      <DropZone accept={ACCEPT} onFiles={uploads.add} disabled={disabled} hint={FORMATS_HINT}>
        Drop files here, or choose them
      </DropZone>
      {uploads.items.length > 0 && (
        <ul className="attachment-list" aria-label="Documents to attach">
          {uploads.items.map((item) => (
            <Row key={item.key} item={item} waiting="Attached on save"
                 onRemove={disabled ? null : uploads.drop} />
          ))}
        </ul>
      )}
    </fieldset>
  );
}
